<template>
	<div class="message-tip">
		<Message
			v-if="messageType == 'showRules'"
			myHeight="270px"
			myWidth="369px"
		>
			<template v-slot:content>
				<div class="rules-wrap">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="rules-text1">积分规则</div>
					<div class="rules-text2-wrap">
						<div>
							<div>1、保持设备开机</div>
							<div>2、保持节点小宝在线</div>
							<div>3、尽量避免卸载或重装节点小宝</div>
							<div>4、优化路由器设置</div>
							<div>优化您的路由器可获得更多的积分收入</div>
							<div>《路由优化指引》</div>
						</div>
					</div>
					<div class="rules-btn-wrap">
						<div class="rules-btn1" @click="closeClick">确 定</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showSetting'"
			myHeight="247px"
			myWidth="369px"
		>
			<template v-slot:content>
				<div class="setting-wrap" v-if="!closeSpeedFlag">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="setting-text1">设置</div>
					<div class="setting-items-wrap">
						<div class="setting-item-wrap">
							<div class="setting-item-name">加速状态</div>
							<div
								:class="{
									'switch-btn': switchFlag == 0,
									'switch-btn1': switchFlag == 1,
								}"
								@click="switchClick"
							></div>
						</div>
						<div class="setting-item-line"></div>
						<div class="setting-item-wrap">
							<div class="setting-item-name">当前缓存</div>
							<div class="setting-item-value">
								{{ cacheused }}G
							</div>
						</div>
					</div>
					<div class="setting-btns">
						<div class="setting-clear-btn" @click="cleanClick">
							<div></div>
							清理缓存
						</div>
						<div class="setting-save-btn" @click="settingSaveClick">
							保存
						</div>
					</div>
				</div>
				<div class="close-speed-wrap" v-if="closeSpeedFlag">
					<div class="close-speed-text1">关闭提示</div>
					<div class="close-speed-text2-wrap">
						<img src="../assets/speed/cache_close.svg" />
						<div>
							关闭后将不再享受加速服务，影响上网体验。确定要关闭共享带宽吗？
						</div>
					</div>
					<div class="close-speed-btn-wrap">
						<div class="close-speed-btn1" @click="closeSpeedClick">
							关闭共享
						</div>
						<div
							class="close-speed-btn2"
							@click="cancelCloseSpeedClick"
						>
							取消
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showSpeedSetting'"
			myHeight="250px"
			myWidth="369px"
		>
			<template v-slot:content>
				<div class="setting-wrap" v-if="!closeSpeedFlag">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="setting-text1">设置</div>
					<div class="setting-items-wrap" style="height: 90px">
						<div class="setting-item-wrap">
							<div class="setting-item-name">共享状态</div>
							<div
								:class="{
									'switch-btn': switchFlag == 0,
									'switch-btn1': switchFlag == 1,
								}"
								@click="switchClick"
							></div>
						</div>
						<div class="setting-item-line"></div>
						<div class="setting-item-wrap">
							<div class="setting-item-name">当前缓存</div>
							<div class="setting-item-value">
								{{ cacheused }}G
							</div>
						</div>
					</div>
					<div class="setting-btns">
						<div class="setting-clear-btn" @click="cleanClick">
							<div></div>
							清理缓存
						</div>
						<div class="setting-save-btn" @click="settingSaveClick">
							保存
						</div>
					</div>
				</div>
				<div class="close-speed-wrap" v-if="closeSpeedFlag">
					<div class="close-speed-text1">关闭提示</div>
					<div class="close-speed-text2-wrap">
						<img src="../assets/speed/cache_close.svg" />
						<div>
							关闭后将不再享受加速服务及积分收益。确定要关闭小宝驿站吗？
						</div>
					</div>
					<div class="close-speed-btn-wrap">
						<div class="close-speed-btn1" @click="closeSpeedClick">
							关闭共享
						</div>
						<div
							class="close-speed-btn2"
							@click="cancelCloseSpeedClick"
						>
							取消
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showClearCache'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="clear-cache-wrap">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="clear-cache-text1">清除缓存</div>
					<div class="clear-cache-line"></div>
					<div class="clear-cache-text2-wrap">
						<img src="../assets/speed/cache_remove.png" />
						<div>
							请确定要清除缓存的大小。（清除缓存将按照由旧到新的顺序清除）
						</div>
					</div>
					<div class="clear-cache-options">
						<div
							:class="percentBtnClickClass(1)"
							@click="percentBtnClick(1)"
						>
							25%
						</div>
						<div
							:class="percentBtnClickClass(2)"
							@click="percentBtnClick(2)"
						>
							50%
						</div>
						<div
							:class="percentBtnClickClass(3)"
							@click="percentBtnClick(3)"
						>
							100%
						</div>
					</div>
					<div class="clear-cache-btn" @click="cacheCleanClick">
						清除缓存
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showCloseSpeed'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="close-speed-wrap">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="close-speed-text1">关闭提示</div>
					<div class="close-speed-text2-wrap">
						<img src="../assets/speed/cache_close.png" />
						<div>
							确定要关闭小宝资源加速吗？关闭后不再享受加速服务。
						</div>
					</div>
					<div class="close-speed-text3">
						注：关闭小宝共享可能影响远程速率
					</div>
					<div class="close-speed-btn-wrap">
						<div
							class="close-speed-btn1"
							@click="closeOrOpenShareClick('off')"
						>
							关闭加速
						</div>
						<div class="close-speed-btn2" @click="closeClick">
							继续加速
						</div>
					</div>
				</div>
			</template>
		</Message>
		<Message
			v-if="messageType == 'showOpenSpeed'"
			:add_device_class="add_device_class"
		>
			<template v-slot:content>
				<div class="open-speed-wrap">
					<img
						src="../assets/home/node/close.png"
						@click="closeClick"
						class="close"
					/>
					<div class="open-speed-text1">开通加速提醒</div>
					<div class="open-speed-text2-wrap">
						<img src="../assets/speed/cache_open.png" />
						<div>
							开启小宝加速将会占用您NAS的部分存储空间。占用空间大小及文件路径可稍后在“设备详情”更改。
						</div>
					</div>
					<div
						class="open-speed-btn"
						@click="closeOrOpenShareClick('on')"
					>
						开启加速
					</div>
					<!--                  <div class="disappear-wrap" @click="disappearClick">-->
					<!--                      <div :class="{'disappear-icon':true,'disappear-icon-checked':disappear_icon_flag}"></div>-->
					<!--                      <div class="disappear-text">同意并接受《隐私政策》《服务协议》</div>-->
					<!--                  </div>-->
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Message from "./Message.vue";

export default {
	components: {
		Message,
	},
	props: {
		messageType: String,
		cacheused: {
			type: Number,
			required: false,
		},
		openSpeedFlag: {
			type: Number,
			required: false,
		},
	},
	data: function () {
		return {
			closeSpeedFlag: false,
			percentFlag: false,
			percentIndex: 1,
			switchFlag: 1, //设置的开关切换，1关 2开
			setting_class: true,
			add_device_class: true, //控制样式的标识
			disappear_icon_flag: false, //移除服务弹框里面的，true选中，false未选中
		};
	},
	methods: {
		settingSaveClick: function () {
			let _that = this;
			_that.$emit("closeMessageAlertClick");
			_that.$emit("closeOrOpenSpeedClick", _that.switchFlag);
		},
		percentBtnClickClass: function (index) {
			let _that = this;
			return _that.percentIndex == index ? "clear-percent-btn" : "";
		},
		percentBtnClick: function (index) {
			let _that = this;
			_that.percentIndex = index;
		},
		cleanClick: function () {
			let _that = this;
			_that.$emit("closeMessageAlertClick");
			_that.$emit("clearCacheClick");
		},
		switchClick: function () {
			let _that = this;
			if (_that.switchFlag == 1) {
				_that.switchFlag = 0;
			} else {
				_that.switchFlag = 1;
				_that.closeSpeedFlag = true;
			}
		},
		closeSpeedClick: function () {
			let _that = this;
			_that.switchFlag = 1;
			_that.closeSpeedFlag = false;
		},
		cancelCloseSpeedClick: function () {
			let _that = this;
			_that.switchFlag = 0;
			_that.closeSpeedFlag = false;
			_that.closeClick();
		},
		disappearClick: function () {
			let _that = this;
			_that.disappear_icon_flag = !_that.disappear_icon_flag;
		},
		closeClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("closeMessageAlertClick");
		},
		closeOrOpenShareClick: function (flag) {
			let _that = this;
			_that.$emit("closeOrOpenShareClick", flag);
			_that.$emit("closeMessageAlertClick");
		},
		cacheCleanClick: function () {
			let _that = this;
			let percent = 0;
			if (_that.percentIndex == 1) {
				percent = 25;
			} else if (_that.percentIndex == 2) {
				percent = 50;
			} else {
				percent = 100;
			}
			_that.$emit("cacheCleanClick", percent);
			_that.$emit("closeMessageAlertClick");
		},
	},
	mounted() {
		let _that = this;
		_that.switchFlag = _that.openSpeedFlag;
	},
};
</script>

<style scoped lang="less">
.message-tip {
	.rules-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.rules-text1 {
			color: #1a1a1a;
			font-size: 15px;
			font-weight: bold;
		}
		.rules-text2-wrap {
			display: flex;
			align-items: center;
			margin: 0 auto;
			margin-top: 24px;
			padding-left: 20px;
			text-align: left;
			width: 328px;
			height: 140px;
			box-sizing: border-box;
			background-color: rgba(240, 175, 45, 0.08);

			img {
				margin-left: 14px;
				margin-right: 10px;
				width: 36px;
				height: 36px;
			}
			div {
				line-height: 20px;
				color: #666666;
				font-size: 12px;
			}
		}

		.rules-btn-wrap {
			display: flex;
			justify-content: center;
			margin-top: 15px;

			.rules-btn1 {
				width: 109px;
				height: 38px;
				line-height: 38px;
				background-color: #fcc11a;
				background-image: linear-gradient(to right, #fcc11a, #faaf1b);
				border-radius: 102px;
				color: #ffffff;
				font-size: 14px;
				cursor: pointer;
			}
		}
	}
	.setting-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;
		font-size: 14px;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.setting-text1 {
			color: #1a1a1a;
			font-size: 15px;
			font-weight: bold;
		}

		.setting-items-wrap {
			margin: 0 auto;
			margin-top: 24px;
			padding-top: 15px;
			background-color: #eff4f6;
			width: 328px;
			height: 100px;
			box-sizing: border-box;
			.setting-item-line {
				margin: 0 auto;
				margin-top: 14px;
				margin-bottom: 14px;
				width: 270px;
				height: 1px;
				background-color: #e2e7e9;
			}
			.setting-item-wrap {
				margin: 0 auto;
				width: 248px;
				height: 20px;
				justify-content: space-between;

				.setting-item-name {
					vertical-align: top;
					width: 100px;
					float: left;
					text-align: left;
				}

				.setting-item-value {
					vertical-align: top;
					width: 100px;
					float: right;
					text-align: right;
				}

				.switch-btn,
				.switch-btn1 {
					width: 41px;
					height: 20px;
					background-image: url("../assets/speed/speed_open.svg");
					background-repeat: no-repeat;
					background-size: 100% 100%;
					background-position: center;
					cursor: pointer;
					float: right;
					vertical-align: top;
				}
				.switch-btn1 {
					background-image: url("../assets/speed/speed_close.svg");
				}
			}
		}
		.setting-btns {
			margin-top: 24px;

			.setting-clear-btn,
			.setting-save-btn {
				width: 109px;
				height: 41px;
				line-height: 41px;
				box-sizing: border-box;
				border-radius: 102px;
				background-color: rgba(53, 77, 130, 0.08);
				border: 1px solid rgba(53, 77, 130, 0.5);
				box-shadow: 0px 0px 5px 1px rgba(193, 193, 193, 0.5);
				cursor: pointer;
				display: inline-block;
				vertical-align: top;
			}
			.setting-clear-btn:hover,
			.setting-save-btn:hover {
				opacity: 0.9;
				cursor: pointer;
			}
			.setting-clear-btn {
				color: #354d82;
				justify-content: center;
				line-height: 40px;

				div {
					margin-right: 3px;
					margin-bottom: 2px;
					width: 17px;
					height: 17px;
					background-image: url("../assets/speed/speed_clear.svg");
					display: inline-block;
					vertical-align: text-bottom;
				}
			}
			.setting-save-btn {
				margin-left: 20px;
				width: 156px;
				background-color: #1f5de3;
				border: none;
				color: #ffffff;
				font-weight: bold;
			}
		}
	}
	.clear-cache-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.clear-cache-text1 {
			color: #1a1a1a;
			font-size: 15px;
			font-weight: bold;
		}
		.clear-cache-line {
			margin-top: 10px;
			width: 100%;
			height: 1px;
			background-color: #e5e5e5;
		}
		.clear-cache-text2-wrap {
			display: flex;
			align-items: center;
			margin: 0 auto;
			margin-top: 10px;
			text-align: left;
			width: 328px;
			height: 68px;
			box-sizing: border-box;
			background-color: rgba(240, 175, 45, 0.08);

			img {
				margin-left: 14px;
				margin-right: 10px;
				width: 36px;
				height: 36px;
			}
			div {
				margin-right: 5px;
				color: #666666;
				font-size: 12px;
			}
		}

		.clear-cache-options {
			display: flex;
			justify-content: center;
			margin-top: 10px;

			div {
				width: 61px;
				height: 22px;
				line-height: 22px;
				border-radius: 2px;
				border: 1px solid #cccccc;
				font-size: 12px;
				color: #666666;
				box-sizing: border-box;
			}
			div:hover {
				cursor: pointer;
				opacity: 0.9;
			}
			div:nth-of-type(n + 2) {
				margin-left: 14px;
			}
			.clear-percent-btn {
				background-color: #f9c357;
				border: none;
				color: #f5f5f5;
				font-weight: bold;
			}
		}
		.clear-cache-btn {
			margin: 0 auto;
			margin-top: 20px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			border-radius: 102px;
			background-color: #f9c357;
			background-image: linear-gradient(to right, #f9c357, #f0af2d);
			font-size: 14px;
			font-weight: bold;
			color: #ffffff;
		}
		.clear-cache-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}

	.close-speed-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.close-speed-text1 {
			color: #1a1a1a;
			font-size: 15px;
			font-weight: bold;
		}
		.close-speed-text2-wrap {
			display: flex;
			align-items: center;
			margin: 0 auto;
			margin-top: 24px;
			text-align: left;
			width: 328px;
			height: 68px;
			box-sizing: border-box;
			background-color: rgba(240, 175, 45, 0.08);

			img {
				margin-left: 14px;
				margin-right: 10px;
				width: 36px;
				height: 36px;
			}
			div {
				margin-right: 5px;
				color: #666666;
				font-size: 12px;
			}
		}

		.close-speed-text3 {
			padding-left: 10px;
			margin-top: 10px;
			font-size: 12px;
			transform: scale(0.85);
			color: #d69b27;
			text-align: left;
		}
		.close-speed-btn-wrap {
			display: flex;
			justify-content: center;
			margin-top: 27px;

			.close-speed-btn1 {
				width: 109px;
				height: 41px;
				line-height: 41px;
				background-color: #cdcdcd;
				background-image: linear-gradient(to right, #cdcdcd, #c0c0c0);
				border-radius: 102px;
				color: #ffffff;
				font-size: 14px;
				cursor: pointer;
			}
			.close-speed-btn2 {
				margin-left: 27px;
				width: 156px;
				height: 41px;
				line-height: 41px;
				background-color: #f9c357;
				border-radius: 102px;
				color: #ffffff;
				font-size: 14px;
				font-weight: bold;
				cursor: pointer;
			}
		}
	}

	.open-speed-wrap {
		position: relative;
		padding-top: 17px;
		text-align: center;

		.close {
			position: absolute;
			top: 17px;
			right: 24px;
			width: 20px;
			height: 20px;
		}

		.open-speed-text1 {
			color: #1a1a1a;
			font-size: 15px;
			font-weight: bold;
		}
		.open-speed-text2-wrap {
			display: flex;
			align-items: center;
			margin: 0 auto;
			margin-top: 20px;
			text-align: left;
			width: 328px;
			height: 84px;
			box-sizing: border-box;
			background-color: #ecf7fd;

			img {
				margin-left: 14px;
				margin-right: 10px;
				width: 36px;
				height: 36px;
			}
			div {
				margin-right: 5px;
				color: #666666;
				font-size: 12px;
			}
		}
		.open-speed-btn {
			margin: 0 auto;
			margin-top: 25px;
			width: 187px;
			height: 41px;
			line-height: 41px;
			border-radius: 102px;
			background-color: #1f5de3;
			font-size: 14px;
			font-weight: bold;
			color: #ffffff;
		}
		.disappear-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 7px;

			.disappear-icon {
				margin-left: 22px;
				width: 10px;
				height: 10px;
				background-repeat: no-repeat;
				background-image: url("../assets/login/uncheck.png");
				background-size: 100% 100%;
			}
			.disappear-icon-checked {
				background-image: url("../assets/speed/agree_active.png");
			}
			.disappear-text {
				margin-left: -12px;
				color: #999999;
				font-size: 12px;
				transform: scale(0.85);
			}
		}
	}
}
</style>
